import { render } from "./ConsolidatedSales.vue?vue&type=template&id=01436472"
import script from "./ConsolidatedSales.vue?vue&type=script&lang=js"
export * from "./ConsolidatedSales.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__